import { FontCategory } from '@quicktools/shared-components/data/fonts';

const props = {
  canonicalPath: 'text/font-generator/symbols/',
  headTitle: 'Symbols Text - Copy & Paste for Free',
  headDescription:
    'Enhance your message with our extensive collection of symbol text which are super easy to copy and paste whenever you want.',
  heading: 'Free Symbol Text Generator',
  description:
    'Easily beautify your content with text symbols. Choose one of the handpicked symbol text fonts below.',
  selectedCategory: FontCategory.SymbolText,
  inputPlaceholder: 'Symbolize your text here…',
};

export default props;
